export const TILES_URL = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
